import React from 'react'
export default function rentree() {
    return (
<>(Année universitaire 2025-2026)</>
        )
}